import { render, staticRenderFns } from "./VersionActions.vue?vue&type=template&id=20d33f1c&scoped=true&"
import script from "./VersionActions.vue?vue&type=script&lang=js&"
export * from "./VersionActions.vue?vue&type=script&lang=js&"
import style0 from "./VersionActions.vue?vue&type=style&index=0&id=20d33f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d33f1c",
  null
  
)

export default component.exports